import { ManualSponsorshipConfiguration } from "interfaces/PartnersInterface";

export const SET_PARTNER = "SET_PARTNER";
export const GET_PARTNER = "GET_PARTNER";

export const SET_BILLING_ITEMS = "SET_BILLING_ITEMS";
export const GET_BILLING_ITEMS = "GET_BILLING_ITEMS";

export const setPartner = partner => {
	return {
		type: SET_PARTNER,
		payload: partner
	};
};

export const getPartner = () => {
	return {
		type: GET_PARTNER
	};
};

export const setBillingItems = ({ manualSponsorshipConfiguration }: { manualSponsorshipConfiguration: ManualSponsorshipConfiguration }) => {
	return {
		type: SET_BILLING_ITEMS,
		payload: {
			manualSponsorshipConfiguration
		}
	};
};

export const getBillingItems = () => {
	return {
		type: GET_BILLING_ITEMS
	};
};
